import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { fetchClientUsersApi } from '../../api/client-users-api';
import { activateAccountApi, deactivateAccountApi } from '../../api/users-api';
import { setQuickLinks } from 'reducers/quick-links-slice';

const initialState = {
  activeColumns: [],
  users: [],
  userRoles: [],
  loading: true,
  pending: false,
  pagination: {},
};

export const activateClientUser = createAsyncThunk('client-users/activate', async (id) => {
  try {
    return await activateAccountApi(id);
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

export const deactivateClientUser = createAsyncThunk('client-users/deactivate', async (id) => {
  try {
    return await deactivateAccountApi(id);
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

export const fetchClientUsersListing = createAsyncThunk(
  'client-users/listing',
  async (updatedParamsObject = {}, { dispatch }) => {
  try {
    const paramsObj = {
      ...updatedParamsObject,
    };
    const res = await fetchClientUsersApi(paramsObj);
    if (res?.status) {
      dispatch(setQuickLinks(res?.user_filters));
    }
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
  },
);

const ClientUsersSlice = createSlice({
  name: 'clientusers',
  initialState,
  reducers: {
    setUsersLoading: (state, action) => {
      state.loading = action?.payload?.loading;
    },
    setClientUsersActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchClientUsersListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchClientUsersListing.fulfilled, (state, action) => {
        if (state.loading) {
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.users = action?.payload?.data || [];
        state.userRoles = action?.payload?.roles || [];
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchClientUsersListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      })
      .addCase(activateClientUser.fulfilled, (state, action) => {
        if (action?.payload?.status) {
          const updated = action.payload.data;
          state.users = state.users.map((u) => (u.id === updated.id ? { ...u, is_active: true } : u));
        }
      })
      .addCase(deactivateClientUser.fulfilled, (state, action) => {
        if (action?.payload?.status) {
          const updated = action.payload.data;
          state.users = state.users.map((u) => (u.id === updated.id ? { ...u, is_active: false } : u));
        }
      });
  },
});

export const { setClientUsersActiveColumn, setUsersLoading } = ClientUsersSlice.actions;
export default ClientUsersSlice.reducer;
